export async function validateAsync(def: any, values: Record<string, unknown>): Promise<string> {
    if (!def) return ""

    const value = values[def.name]
    const rules = def.rules || []

    for (const rule of rules) {

        if (rule.type === "unique") {
            try {
                const res = await fetch(rule.endpoint, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ [rule.key]: value }),
                })

                const data = await res.json()
                if (data?.[rule.availableKey || "available"] !== true) {
                    return rule.message || "Bereits vergeben"
                }
            } catch {
                return rule.message || "Validierung fehlgeschlagen"
            }
        }

        if (rule.type === "custom") {
            const ok = await rule.check(value, values)
            if (!ok) {
                return rule.message || "Ungültig"
            }
        }
    }

    return ""
}
